/* 仅加载离线预处理器标记的媒体；不在浏览器里拦截原生 src，也不接管已有懒加载逻辑。 */
(() => {
  if (window.FankaDetailMediaLazy) return;

  // 扩展范围时在这里添加 '.test-a video'、'.test-b img' 等；相应 HTML 必须先完成预处理。
  const SELECTORS = [
    '.fanka-product-detail-description video',
    '.fanka-product-detail-description img',
  ];
  const MARKER = 'data-fanka-lazy-media';
  const PENDING = `[${MARKER}="pending"]`;
  const selector = SELECTORS.join(',');
  const observed = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const { target, isIntersecting } of entries) {
      if (!isIntersecting) continue;
      load(target);
      observer.unobserve(target);
      observed.delete(target);
    }
  }, { rootMargin: '300px 0px' }) : null;

  function restore(element) {
    let changed = false;
    // 先恢复 sizes 和候选源，避免浏览器按错误尺寸或默认图片发起额外请求。
    for (const name of ['sizes', 'srcset', 'poster', 'src']) {
      const value = element.getAttribute(`data-${name}`);
      if (value === null || element.hasAttribute(name)) continue;
      element.setAttribute(name, value);
      element.removeAttribute(`data-${name}`);
      changed = true;
    }
    return changed;
  }

  function load(element) {
    if (!(element instanceof Element) || !element.matches(selector) || !element.matches(PENDING)) return;
    const video = element.localName === 'video';
    if (!video && element.localName !== 'img') return;
    const parent = video ? element : element.parentElement?.localName === 'picture' ? element.parentElement : null;
    let changed = false;
    // source 跟随拥有者恢复，不单独观察无布局盒子的 source 标签。
    for (const source of parent?.children || []) {
      if (source.localName === 'source') {
        changed = restore(source) || changed;
        source.setAttribute(MARKER, 'loaded');
      }
    }
    changed = restore(element) || changed;
    element.setAttribute(MARKER, 'loaded');
    if (video && changed) {
      element.load();
      if (element.autoplay) element.play().catch(() => {});
    }
  }

  function observe(element) {
    if (!element.matches(selector) || !element.matches(PENDING) || observed.has(element)) return;
    // 不支持 IntersectionObserver 时保持默认不加载，可由明确交互调用 load。
    if (!observer) return;
    observed.add(element);
    observer.observe(element);
  }

  function scan(root = document) {
    if (root instanceof Element && root.matches(PENDING)) observe(root);
    root.querySelectorAll?.(PENDING).forEach(observe);
  }

  function init() {
    scan();
    new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'attributes') {
          if (record.target.matches(PENDING)) observe(record.target);
          continue;
        }
        for (const node of record.removedNodes) {
          if (!(node instanceof Element)) continue;
          for (const element of [node, ...node.querySelectorAll(PENDING)]) {
            if (!element.isConnected && observed.has(element)) {
              observer?.unobserve(element);
              observed.delete(element);
            }
          }
        }
        for (const node of record.addedNodes) {
          if (node instanceof Element) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: [MARKER] });
  }
  window.FankaDetailMediaLazy = { selectors: SELECTORS, scan, load };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
